const OtherQandA = [
    {
      question: 'Why do I need an agent?',
      num: 1,
      ans: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
      ]
    },
    {
      question: 'What is the "closing" cost?',
      num: 2,
      ans: [
        "Suspendisse rhoncus justo sit amet felis pulvinar tempus."
      ]
    },
    {
      question: 'How do i know what to list my house for?',
      num: 3,
      ans: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
      ]
    },
    {
      question: 'Do i need a downpayment to buy a house?',
      num: 4,
      ans: [
        "Suspendisse rhoncus justo sit amet felis pulvinar tempus.."
      ]
    },
    {
      question: 'What are the selling/buying process like?',
      num: 5,
      ans: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
      ]
    },
  ]

  export default OtherQandA;